import { ca } from '@cian/analytics';

export function trackClickAboutCheckingMethod() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'Click',
    label: 'check_method',
    useLastProducts: true,
  });
}
